import {useContext, useEffect} from 'react'
import {MemoryRouter, Route, Routes, useLocation, useSearchParams} from 'react-router-dom'
import AuthSelection from '../components/Screens/AuthSelection'
import {AppContext} from '../contexts/AppContextProvider'
import NatureOfComplaint from '../components/Screens/NatureOfComplaint'
import ProductSearch from '../components/Screens/ProductSearch'
import ProductType from '../components/Screens/ProductType'
import EventOccurrence from '../components/Screens/EventOccurrence'
import TreatmentDates from '../components/Screens/TreatmentDates'
import PatientInfo from '../components/Screens/PatientInfo'
import AbutmentsInformation from '../components/Screens/AbutmentsInformation'
import InstrumentInformation from '../components/Screens/InstrumentInformation'
import AvailableToReturn from '../components/Screens/AvailableToReturn'
import ClinicalCondition from '../components/Screens/ClinicalConditions/ClinicalCondition'
import ComplaintType from '../components/Screens/ComplaintTypes/ComplaintType'
import ShippingInfo from '../components/Screens/ShippingInfo'
import ComplaintCompletion from '../components/Screens/ComplaintCompletion'
import ScrollToTop from '../components/ScrollToTop'
import SecondaryDevice from '../components/Screens/SecondaryDevice'
import {screenPaths} from '../hooks/useScreenFlow'
import GuestForm from '../components/Screens/GuestForm'
import HUD from '../HUD'

export const PageTracker = () => {
    const {pathname} = useLocation()

    useEffect(() => {
        const url = new URL(window.location.toString())
        url.searchParams.set('location', encodeURI(pathname.replaceAll('/', '')) || 'index');
        window.history.pushState(null, '', url.toString());
    }, [pathname])

    return null;
}

const AppRouter = () => {
    const {loggedIn} = useContext(AppContext)

    return (
        <MemoryRouter initialEntries={JSON.parse(sessionStorage.getItem('history') || '["/"]')}>
            <ScrollToTop/>
            <PageTracker/>
            <Routes>
                <Route path={screenPaths.natureOfComplaint} element={<HUD/>}>
                    {
                        loggedIn
                            ? <Route index={loggedIn} element={<NatureOfComplaint/>}/>
                            : (
                                <>
                                    <Route index={!loggedIn} element={<AuthSelection/>}/>
                                    <Route path={screenPaths.natureOfComplaintGuest} element={<NatureOfComplaint/>}/>
                                </>
                            )
                    }

                    <Route path={screenPaths.guestForm} element={<GuestForm/>}/>
                    <Route path={screenPaths.productSearch} element={<ProductSearch/>}/>
                    <Route path={screenPaths.productType} element={<ProductType/>}/>
                    <Route path={screenPaths.eventOccurrence} element={<EventOccurrence/>}/>
                    <Route path={screenPaths.treatmentDates} element={<TreatmentDates/>}/>
                    <Route path={screenPaths.patientInfo} element={<PatientInfo/>}/>
                    <Route path={screenPaths.abutmentsInformation} element={<AbutmentsInformation/>}/>
                    <Route path={screenPaths.instrumentInformation} element={<InstrumentInformation/>}/>
                    <Route path={screenPaths.secondaryDevice} element={<SecondaryDevice/>}/>
                    <Route path={screenPaths.availableToReturn} element={<AvailableToReturn/>}/>
                    <Route path={screenPaths.complaintType} element={<ComplaintType/>}/>
                    <Route path={screenPaths.clinicalCondition} element={<ClinicalCondition/>}/>
                    <Route path={screenPaths.shippingInfo} element={<ShippingInfo/>}/>
                    <Route path={screenPaths.complaintCompletion} element={<ComplaintCompletion/>}/>
                </Route>
            </Routes>
        </MemoryRouter>
    )
}
export default AppRouter
